"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var paste_1 = require("../pastes/paste");
var codefile_1 = require("../pastes/codefile");
var pastefile_1 = require("../pastes/pastefile");
var PasteParserV1 = /** @class */ (function () {
    function PasteParserV1() {
    }
    PasteParserV1.prototype.parse = function (name, key, pasteData) {
        var paste = new paste_1.default(name, key);
        if (pasteData.type == "code") {
            paste.files = pasteData.files.map(function (file) {
                return new codefile_1.default(file.id, file.name, file.contents, file.type);
            });
        }
        else {
            var file = new pastefile_1.default(0, pasteData.name, pasteData.data, pasteData.mime);
            paste.files.push(file);
        }
        return paste;
    };
    return PasteParserV1;
}());
exports.default = PasteParserV1;
